﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

var facebook = require('../../helper/facebook');
import * as Entities_Empty from '../../../lib/entities/empty';

import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Template from '../../../portal/info/template/template';

import GsapRegion from '../../../lib/views/gsapRegion/gsapRegion';

import tpl_page from './tpl/page.html';

var gsapRegion = GsapRegion.extend({
    //el: "#template"
});

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_page({ model: this.model.toJSON() });
    },
    regions: {
        template: {
            selector: "#template", regionClass: gsapRegion
        }
    },
    initialize: function () {
        this.app = this.options.app;
    },
    onBeforeShow: function () {
        this.selectedModel = this.collection.where({ Selected: 1 })[0];
        this.selectedModel_collection = new Backbone.Collection(this.selectedModel.attributes.Collection);

        this.old_View_Template = new View_Template({ model: this.selectedModel, collection: this.selectedModel_collection, app: this.app, eventId: this.options.eventId, customEvent: this.options.customEvent });
        this.template.show(this.old_View_Template);
    },
}, Backbone.Radio.Requests);